import React from "react";
import { Typography, Box } from "@mui/material";

const AuthHeader = ({
  accountLabel,
  providerName,
  title,
  description,
}) => {
  return (
    <Box>
      {(accountLabel || providerName) && (
        <Typography
          sx={{
            color: "#5f48f6",
            fontSize: 13,
            fontWeight: 700,
            letterSpacing: 0,
            lineHeight: 1.4,
          }}
        >
          {accountLabel}
          {accountLabel && providerName && " · "}
          {providerName}
        </Typography>
      )}

      <Typography
        component="h1"
        sx={{
          color: "#111827",
          fontSize: { xs: 24, sm: 28 },
          fontWeight: 700,
          lineHeight: 1.12,
          mt: 1,
        }}
      >
        {title}
      </Typography>

      <Typography
        sx={{
          color: "#64748b",
          fontSize: 14,
          lineHeight: 1.5,
          mt: 1.25,
        }}
      >
        {description}
      </Typography>
    </Box>
  );
};

export default AuthHeader;
